import React, { Component, Fragment, useRef } from "react";
//import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  CardText,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import Swal from "sweetalert2";
//import { rgbToHex } from "@coreui/coreui/dist/js/coreui-utilities";
import Axios from "axios";
import { configuration } from "../appConfig";
import ScanQR from "./ScanQR";
//import { configuration } from "../appConfig";
import "./createqr.css";
import { connect } from "react-redux";
import axios from "axios";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
const hzdPartnerIdList = ["6-200406", "16-220515"];

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class CreateQr extends Component {
  constructor(props) {
    super(props);
    this.qrRef = React.createRef(null);
    this.state = {
      selectedFile: "",
      regNo: "",
      vin: "",
      make: "",
      model: "",
      color: "",
      estimateId: "",
      client: "Adi",
      InsurenceName: "",
      insurenceLogo: "",
      makeModel: [],
      Models: [],
      email: "",
      comment: "",
      words: {},
      lang: "",
      modal: false,
      clients: [
        {
          SN: "1",
          Logo: "Adi.png",
          Notes: "Thank you",
          Email: "sa@pt3d.de",
          Name: "Adi",
        },
        {
          SN: "2",
          Logo: "AIG.png",
          Notes: "Thank you",
          Email: "sa@pt3d.de",
          Name: "AIG",
        },
      ],
      Category: "",
      categoryList: [
        "I. Kategorie",
        "II. Kategorie",
        "III. Kategorie",
        "IV. Kategorie",
        "V. Kategorie",
      ],
      ScannerNumber: "",
      ScannerLocation: "",
      error: [],
      modalError: [],
      // scanner State
      scanQR: false,
      scanResultData: "",
      qrClient: "",
      claimNumber: "",
      customerCompany: "",
      customerName: "",
      PartnerName: "",
      kilometerStand: "",
      legacyMode: "",
      Category: "",
      actualVin: "",
      colorArr: {
        us: [
          { title: "Beige", value: "F5F5DC" },
          { title: "Black", value: "000" },
          { title: "Blue", value: "0000FF" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Brown", value: "964B00" },
          { title: "Gold", value: "FFD700" },
          { title: "Green", value: "32AA32" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Violet", value: "8F00FF" },
          { title: "White", value: "FFFFFF" },
          { title: "Yellow", value: "FFFF00" },
        ],
        de: [
          { title: "Beige", value: "F5F5DC" },
          { title: "Blue", value: "0000FF" },
          { title: "Brown", value: "964B00" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Gold", value: "FFD700" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Green", value: "32AA32" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Black", value: "000" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Violet", value: "8F00FF" },
          { title: "White", value: "FFFFFF" },
        ],
        cz: [
          { title: "Beige", value: "F5F5DC" },
          { title: "White", value: "FFFFFF" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Black", value: "000" },
          { title: "Red", value: "960A0A" },
          { title: "Brown", value: "964B00" },
          { title: "Blue", value: "0000FF" },
          { title: "Orange", value: "F09600" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Violet", value: "8F00FF" },
          { title: "Green", value: "32AA32" },
          { title: "Gold", value: "FFD700" },
          { title: "Yellow", value: "FFFF00" },
        ],
        ro: [
          { title: "White", value: "FFFFFF" },
          { title: "Blue", value: "0000FF" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Gold", value: "FFD700" },
          { title: "Beige", value: "F5F5DC" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Brown", value: "964B00" },
          { title: "Black", value: "000" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Green", value: "32AA32" },
          { title: "Violet", value: "8F00FF" },
        ],

        si: [
          { title: "White", value: "FFFFFF" },
          { title: "Beige", value: "F5F5DC" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Black", value: "000" },
          { title: "Blue", value: "0000FF" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Brown", value: "964B00" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Violet", value: "8F00FF" },
          { title: "Green", value: "32AA32" },
          { title: "Gold", value: "FFD700" },
        ],
        fr: [
          { title: "Silver", value: "C0C0C0" },
          { title: "Beige", value: "F5F5DC" },
          { title: "White", value: "FFFFFF" },
          { title: "Blue", value: "0000FF" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Brown", value: "964B00" },
          { title: "Black", value: "000" },
          { title: "Gold", value: "FFD700" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Green", value: "32AA32" },
          { title: "Violet", value: "8F00FF" },
        ],
        it: [
          { title: "Orange", value: "F09600" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Beige", value: "F5F5DC" },
          { title: "White", value: "FFFFFF" },
          { title: "Blue", value: "0000FF" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Brown", value: "964B00" },
          { title: "Black", value: "000" },
          { title: "Gold", value: "FFD700" },
          { title: "Red", value: "960A0A" },
          { title: "Green", value: "32AA32" },
          { title: "Violet", value: "8F00FF" },
        ],
        nl: [
          { title: "Beige", value: "F5F5DC" },
          { title: "Blue", value: "0000FF" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Brown", value: "964B00" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Gold", value: "FFD700" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Green", value: "32AA32" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Violet", value: "8F00FF" },
          { title: "White", value: "FFFFFF" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Black", value: "000" },
        ],
        pl: [
          { title: "Beige", value: "F5F5DC" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Brown", value: "964B00" },
          { title: "White", value: "FFFFFF" },
          { title: "Black", value: "000" },
          { title: "Red", value: "960A0A" },
          { title: "Violet", value: "8F00FF" },
          { title: "Blue", value: "0000FF" },
          { title: "Orange", value: "F09600" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Green", value: "32AA32" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Gold", value: "FFD700" },
        ],
      },
      regDate: "",
      loader: false,
      customerJSON: {},
    };
  }

  filEditForm = async () => {
    {
      this.props.location.state.detail._original
        ? // for Data Table
          this.setState({
            isUpdate: this.props.location.state.isUpdate,
            ...this.props.location.state.detail._original,
          })
        : // for normal
          this.setState({
            ...this.props.location.state.detail,
            regDate: this.formatDate(
              this.props.location.state.detail.regDate || ""
            ),
            regNo: this.props.location.state.detail.reg,
            isUpdate: this.props.location.state.isUpdate,
            InsurenceName: this.props.location.state.detail.InsurenceName,
            qrClient: this.props.location.state.detail.client,
            // PartnerName: this.props.location.state.detail.customerName,
            customerName: this.props.location.state.detail.customerName,
          });
    }

    if (
      this.props.location.state.detail._original &&
      this.props.location.state.detail._original.make
    ) {
      // for data Table
      const make = this.props.location.state.detail._original.make;
      await this.getMakeModel();
      const Models = this.state.makeModel.filter((data) => {
        return data.Make == make;
      });
      this.setState({
        Models: Models[0].Model,
      });
    } else if (this.props.location.state.detail.make) {
      // for normal
      const make = this.props.location.state.detail.make;
      await this.getMakeModel();
      let Models = this.state.makeModel.filter((data) => {
        return data.Make == make;
      });
      let makeModels = this.state.makeModel;
      if (Models.length == 0) {
        Models = this.getModals(make);
        makeModels = [
          {
            Make: make,
            Model: [this.state.model, ...Models, ...this.state.Models].sort(),
          },
          ...this.state.makeModel,
        ];
        this.setState({
          Models: [this.state.model, ...this.state.Models, ...Models].sort(),
          makeModel: makeModels,
        });
      } else if (!Models[0].Model.includes(this.state.model)) {
        this.setState({
          Models: Models.length
            ? [this.state.model, ...Models[0].Model].sort()
            : "",
        });
      } else {
        this.setState({
          Models: Models.length ? Models[0].Model : "",
        });
      }
    } else {
      await this.getMakeModel();
    }
    this.setState({
      InsurenceName: this.props.location.state.detail.client,
    });
  };
  getMakeModel = async () => {
    await Axios.get("makeModel.json").then((r) => {
      this.setState({ makeModel: r.data });
    });
  };

  componentDidMount() {
    this.getInsurenceClients();
    const client = localStorage.getItem("client");
    this.setState({ client });

    if (this.props.location.state) {
      this.filEditForm();
    } else {
      this.getMakeModel();
    }

    // this.customerInfo();
    // this.vinFolderList();
    this.getLang();
  }
  getInsurenceClients = () => {
    const partnerId = localStorage.getItem("partnerId");
    ///Axios.get(`insurenceClients/${partnerId}/insurenceList.json`).then(res=>{
    const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
    Axios.get(url).then((res) => {
      if (res.data) {
        this.setState({
          clients: res.data,
          InsurenceName: this.state.InsurenceName || res.data[0].Name,
          insurenceLogo: this.state.InsurenceName
            ? this.getLogo(res.data, this.state.InsurenceName)
            : res.data[0].Logo,
        });
      }
    });
  };
  getLogo = (data, InsurenceName) => {
    let logo;
    data.length &&
      data.filter((obj) => {
        if (obj.Name === InsurenceName) {
          logo = obj.Logo;
        }
      });
    return logo;
  };
  handleChange = (e, type) => {
    const [name, value] = [e.target.name, e.target.value];
    this.setState({
      [name]: value,
    });
    if (type === "InsurenceName") {
      this.state.clients.map((client) => {
        if (client.Name === e.target.value) {
          this.setState({
            insurenceLogo: client.Logo,
          });
        }
      });
    }
  };
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.lang !== this.state.lang) {
      this.setState({
        lang: nextProps.lang,
      });
    } else return null;
  };

  translateColorName = async () => {
    const { colorArr } = this.state;
    colorArr &&
      colorArr.length &&
      colorArr.map(async (color) => {
        let colorName = await this.lang(color.title);
        color.colorName = colorName;
        return color;
      });
    return colorArr;
  };

  sortColorArr = async () => {
    const { colorArr } = this.state;
    await this.translateColorName();
    let finaleArr = await colorArr.sort((a, b) => {
      let nameA = a.colorName;
      let nameB = b.colorName;

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    });
    this.setState({
      colorArr: finaleArr,
    });
  };
  save = () => {
    const { vin, estimateId } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");
    // for Scanner Info location
    let error = [];
    let newVIN = client === "SWISS" ? estimateId : vin;
    // if(this.state.vin.trim() === '') {
    //   error.push('VIN')
    // }else
    if (!/^[a-zA-Z0-9_.-]*$/.test(newVIN)) {
      error.push("inValidVIN");
    }
    if (newVIN.length > 17) {
      if (newVIN[17] !== "_") {
        error.push("maxLength");
      }
    }

    if (estimateId.trim() === "" && client === "SWISS") {
      error.push("orderID");
    }

    if (error.length) {
      this.setState({
        error: error,
      });
    } else {
      this.setState({
        error: [],
      });
      let url = `${configuration.vinExistsOrNot}?partnerId=${partnerId}&vin=${newVIN}`;
      if (newVIN.trim() === "") {
        this.saveQR();
      } else {
        Axios.get(url)
          .then((res) => {
            if (res.data.status === 200) {
              this.saveQR();
              this.handleChangeExtraImages(newVIN);
            } else if (
              res.data.status === 200 &&
              res.data.data == "vin not exists"
            ) {
              this.props.history.push("/createQR");
            } else if (res.data.status === 500) {
              Swal.fire({
                title: `<p className="swal-custome-text">${this.lang(
                  "VIN already exists! Do you want to overwrite the order data? Overwriting will delete all scan images and analysis data for this VIN. Press <span>YES</span> to proceed and <span>NO</span> to return back."
                )}</p>`,
                showCancelButton: true,
                confirmButtonText: this.lang("Yes"),
                cancelButtonText: this.lang("No"),
                confirmButtonColor: "#d80707",
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.value) {
                  Axios.get(`${url}&deleteFolderData`)
                    .then((res) => {
                      if (res.data.success) {
                        this.saveQR();
                      }
                    })
                    .catch((err) => {
                      alert(err);
                    });
                }
              });
            }
          })
          .catch((err) => {
            alert(err);
          });
      }
    }
  };
  handleChangeExtraImages = (newVIN) => {
    let partnerId = localStorage.getItem("partnerId");
    const vinNo = localStorage.getItem("selectedFile");
    let payload = {
      partnerId,
      vin: newVIN || vinNo,
      flag: 1,
    };
    const url = configuration.predamageFlag;
    axios.post(url, payload).then((res) => {});
  };
  saveQR = () => {
    const partnerId = localStorage.getItem("partnerId");
    const {
      vin,
      make,
      model,
      color,
      estimateId,
      regNo,
      client,
      InsurenceName,
      email,
      comment,
      PartnerName,
      customerName,
      customerCompany,
      claimNumber,
      qrClient,
      kilometerStand,
      Category,
      actualVin,
      regDate,
      customerJSON,
    } = this.state;
    // if (this.state.vin) {
    // const url = `${configuration.imagePath}/api_v2/createVinRecord.php?vin=${vin.toUpperCase()}&partnerId=${partnerId}&regNo=${regNo}&make=${make}&model=${model}&color=${color}&estimateId=${estimateId}`;
    const url = `${configuration.imagePath}/api_v2/createVinRecord.php`;
    //window.open (url)
    let updatedCustomerCompany = customerCompany || '';
    // Update customer company for specific partnerId and insurance names
    if (partnerId === "Helvetia-001") {
      const helvetia = 'Helvetia'.toLowerCase();
      const smile = 'Smile'.toLowerCase();
      const HelvetiaReplacements = [
          { contractor: helvetia, company: 'Helvetia Versicherung' },
          { contractor: smile, company: 'Helvetia Versicherung' },
      ];
      
      HelvetiaReplacements.forEach(replacement => {
          if (qrClient && qrClient.toLowerCase().includes(replacement.contractor) && !updatedCustomerCompany.includes(replacement.company)) {
              updatedCustomerCompany = replacement.company;
          }
      });
  }
    const data = new FormData();
    // data.append("img", this.state.extTmages[i]"vin"];
    if (client === "SWISS") {
      data.append("vin", estimateId.toUpperCase());
      data.append("client_type", "SWISS");
    } else {
      data.append("vin", vin.toUpperCase());
    }
    data.append("partnerId", partnerId);
    data.append("regNo", regNo);
    data.append("make", make);
    data.append("model", model);
    data.append("color", color);
    data.append("estimateId", estimateId);
    data.append("email", email);
    data.append("comment", comment);
    data.append("InsurenceName", qrClient);
    data.append("CustomerName", customerName);
    data.append("customerCompany", updatedCustomerCompany);
    data.append("claimNumber", claimNumber);
    data.append("client", qrClient);
    data.append("KilometerStand", kilometerStand);
    data.append("Category", Category);
    data.append("actualVin", actualVin.toUpperCase() || vin.toUpperCase());
    hzdPartnerIdList.includes(partnerId) &&
      Object.keys(customerJSON).length > 0 &&
      data.append("customerJSON", JSON.stringify(customerJSON));
    partnerId === "15-220410" && data.append("regDate", regDate);
    partnerId === "demo-cz" && data.append("regDate", regDate);
    Axios.post(url, data).then(
      (res) => {
        if (res.data.status === 400) {
          this.props.history.push("/createQR");
          Toast.fire({
            type: "error",
            title: "vin number is not valid",
          });
        } else {
          this.props.history.push("/qrlist");
        }
        // this.props.history.push("/qrlist");
        //window.open (`https://drivenscan.app/qr/DisplayQR.php?estimateID=&vin=${this.state.vin}&regno=&make=&model=&color=`,"_blank")
        // if(res.data.status === 200){
        // this.props.history.push("/qrlist");
        // }  else if(res.data.status === 400){
        //   Toast.fire({
        //     type: 'error',
        //     title: 'VIN number is invalid!'
        //   })
        // } else {
        // Toast.fire({
        //   type: 'error',
        //   title: 'Somethimg went to wrong!'
        // })
        // }
      }

      // window.open (`https://drivenscan.app/qr/DisplayQR.php?estimateID=&vin=${this.state.vin}&regno=&make=&model=&color=`,"_blank")
    );
    // }
    // else {
    //   alert("Select Vin");
    // }
  };
  // create Empty vin
  createEmpty = () => {
    // validation
    if (this.state.vin.length) {
      Toast.fire({
        type: "error",
        title: "Please do not fill VIN No.",
      });
    } else {
      let payload = {
        partnerId: localStorage.getItem("partnerId"),
        regNo: this.state.regNo,
        estimateId: this.state.estimateId,
        color: this.state.color,
        make: this.state.make,
        model: this.state.model,
        email: this.state.email,
        comment: this.state.comment,
        InsurenceName: this.state.InsurenceName,
      };
      let url = configuration.createEmptyVin;
      Axios.post(url, payload, {
        headers: {
          "Content-type": "application/json",
        },
      })
        .then((res) => {
          if (res.data.success) {
            Toast.fire({
              type: "success",
              title: res.data.message,
            });
          } else {
            Toast.fire({
              type: "error",
              title: res.data.message,
            });
          }
        })
        .catch((err) => {
          // if(err ===  "404"){
          //   Toast.fire({
          //     type: 'error',
          //     title: 'Empty Vin create successfull'
          //   })
          // } else if (err === "500"){
          //   Toast.fire({
          //     type: 'error',
          //     title: 'Internal Server Error. Please try again later.'
          //   })
          // } else{
          //   Toast.fire({
          //     type: 'error',
          //     title: 'else!!!!'
          //   })
          // }
        });
    }
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };

  handleSubmit = (type) => {
    var content = this.state.base64;

    var fdata = content.replace("data:image/jpeg;base64,", "");
    var url =
      "https://vision.googleapis.com/v1/images:annotate?key=AIzaSyD2qzy2goNPeb2Xx89mDMoLOA_J_KCtV9s";
    //const url = "https://api.ocr.space/parse/image";
    var data = {
      requests: [
        {
          image: {
            content: fdata,
          },
          features: [
            {
              type: "TEXT_DETECTION",
              maxResults: 200,
            },
          ],
        },
      ],
    };

    Axios.post(url, data)
      .then((res) => {
        var a =
          res.data.responses[0].textAnnotations[0].description.split("\n")[0];
        var b = a.replace(/[^a-z0-9]/gi, "");

        this.setState({ [type]: b });
      })
      .catch((err) => {});
  };

  getOcr = (event, type) => {
    //var file = $('#fileform [name=fileField]')[0].files[0];

    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        file: file,
        base64: reader.result,
      });
      this.handleSubmit(type);
    };

    //  const data = new FormData()
    //data.append('url', event.target.files[0]);
  };
  toggle = (type) => {
    console.log(type);
    let legacyMode;
    type === "scanner" ? (legacyMode = false) : (legacyMode = true);
    this.setState({
      modal: !this.state.modal,
      legacyMode,
    });
  };
  update = () => {
    const {
      vin,
      make,
      model,
      color,
      estimateId,
      regNo,
      customerCompany,
      InsurenceName,
      email,
      comment,
      qrClient,
      claimNumber,
      PartnerName,
      customerName,
      partnerId,
      kilometerStand,
      Category,
      regDate,
    } = this.state;
    let payload = {
      partnerId: partnerId,
      vin: vin.toUpperCase(),
      estimateId: estimateId,
      regNo: regNo,
      make: make,
      model: model,
      color: color,
      InsurenceName: InsurenceName,
      email: email,
      comment: comment,
      CustomerName: customerName,
      // customerName:PartnerName,
      customerCompany: customerCompany,
      claimNumber: claimNumber,
      client: qrClient,
      KilometerStand: kilometerStand,
      Category: Category,
      regDate: regDate,
    };
    const url = configuration.updateQrList;
    Axios.post(url, payload)
      .then((res) => {
        if (res.data.success) {
          Toast.fire({
            type: "success",
            title: "Data Updated Successfully",
          });
          this.props.history.push("/qrlist");
        } else if (res.data.status === 400) {
          Toast.fire({
            type: "error",
            title: "VIN number is invalid!",
          });
        } else {
          Toast.fire({
            type: "error",
            title: "Somethimg went to wrong!",
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: err,
        });
      });
  };
  handleScanWebCam = (newData, qrString, Client) => {
    if (Client) {
      if (localStorage.getItem("client") === "SWISS") {
        this.setState({
          qrClient: Client,
        });
      }
    }
    this.setState(
      {
        scanQrData: newData,
        qrString,
      },
      () => this.toggle()
    );
    if (newData) {
      this.finalMatch(newData);
    }
  };

  finalMatch = (dataArray) => {
    const { qrClient } = this.state;
    const client = localStorage.getItem("client");
    dataArray.length &&
      dataArray.map((arr) => {
        arr.length &&
          arr.map((r, i) => {
            if (i % 2 === 0) {
              let decodedValue;
              console.log(decodedValue);
              if (arr[i + 1] !== undefined) {
                decodedValue = decodeURIComponent(
                  arr[i + 1].replace(/\+/g, " ")
                );
              }
              if (["OrderNo", "Auftragsnummer", "ActualVin", "VIN", "RegNo", "KZ"].includes(arr[i])) {
              decodedValue = decodedValue.replace(/\./g, "");
            }
              if (
                arr[i] === "ActualVin" ||
                arr[i] === "vin" ||
                arr[i] === "VIN"
              ) {
                if (client === "SWISS") {
                  this.setState({
                    actualVin: decodedValue,
                  });
                } else {
                  this.setState({
                    vin: decodedValue,
                    actualVin: decodedValue,
                  });
                }
              } else if (
                arr[i] === "RegNo" ||
                arr[i] === "regno" ||
                arr[i] === "KZ"
              ) {
                this.setState({
                  regNo: decodedValue,
                });
              } else if (
                arr[i] === "OrderNo" ||
                arr[i] === "estimateID" ||
                arr[i] === "Auftragsnummer"
              ) {
                if (client === "SWISS") {
                  this.setState({
                    estimateId: decodedValue,
                    vin: decodedValue,
                  });
                } else {
                  this.setState({
                    estimateId: decodedValue,
                  });
                }
              } else if (
                arr[i] === "Make" ||
                arr[i] === "make" ||
                arr[i] === "Marke"
              ) {
                let Models = this.state.makeModel.filter((t) => {
                  return t.Make == decodedValue;
                });
                // let makeModels = this.state.makeModel
                // if(Models.length == 0){
                //   makeModels = [{
                //     "Make": decodedValue,
                //     "Model": [],
                //   }, ...this.state.makeModel]
                // }
                this.setState({
                  make: decodedValue,
                  Models:
                    Models.length && Models[0].Model ? Models[0].Model : [],
                });
              } else if (
                arr[i] === "Model" ||
                arr[i] === "model" ||
                arr[i] === "Typ"
              ) {
                let makeModels = [...this.state.makeModel];
                let Models = [];
                if (this.state.Models.length == 0) {
                  Models = this.getModals(this.state.make);

                  makeModels = [
                    {
                      Make: this.state.make,
                      Model: [
                        decodedValue,
                        ...Models,
                        ...this.state.Models,
                      ].sort(),
                    },
                    ...this.state.makeModel,
                  ];
                }
                this.setState({
                  model: decodedValue,
                  Models: [
                    decodedValue,
                    ...this.state.Models,
                    ...Models,
                  ].sort(),
                  makeModel: makeModels,
                });
              } else if (
                arr[i] === "Color" ||
                arr[i] === "color" ||
                arr[i] === "Farbe"
              ) {
                this.setState({
                  color: decodedValue,
                  // colorArr : [decodedValue, ...this.state.colorArr]
                });
              } else if (arr[i] === "Auftragsgeber" || arr[i] === "PartnerName") {
                this.setState({
                  customerName: decodedValue,
                  // colorArr : [decodedValue, ...this.state.colorArr]
                });
              } else if (arr[i] === "Firma" || arr[i] === "customerCompany") {
                this.setState({
                  customerCompany: decodedValue,
                  // colorArr : [decodedValue, ...this.state.colorArr]
                });
              // } else if (arr[i] === "Name") {
              //   this.setState({
              //     qrClient: decodedValue,
              //     // colorArr : [decodedValue, ...this.state.colorArr]
              //   });
              } else if (arr[i] === "Email") {
                this.setState({
                  email: decodedValue,
                  // colorArr : [decodedValue, ...this.state.colorArr]
                });
              } else if (arr[i] === "KM") {
                this.setState({
                  kilometerStand: decodedValue,
                  // colorArr : [decodedValue, ...this.state.colorArr]
                });
              } else if (arr[i] === "client") {
                // if (client === "SWISS") {
                //   if (qrClient == "amag") {
                //     var d1 =
                //       decodedValue.includes("AMAG") ||
                //       decodedValue.includes("amag")
                //         ? decodedValue
                //         : `Amag - ${decodedValue}`;
                //     this.setState({
                //       // qrClient : decodedValue
                //       qrClient: d1,
                //     });
                //   } else {
                //     // var d2 = `die ${decodedValue}`
                //     this.setState({
                //       qrClient: decodedValue,
                //     });
                //   }
                // } else {
                //   this.setState({
                //     qrClient: decodedValue,
                //   });
                // }
                this.setState({
                  qrClient: decodedValue,
                  InsurenceName: decodedValue,
                  });
              } else {
                this.setState({
                  [arr[i]]: decodedValue,
                });
              }
            } else {
              return;
            }
          });
      });
  };
  getModals = (make) => {
    let Models = this.state.makeModel.filter((t) => {
      return (t.Make && t.Make.toLowerCase()) === make.toLowerCase();
    });
    Models =
      Models.length && Models[0].hasOwnProperty("Model") ? Models[0].Model : [];
    return Models.length ? Models : [];
  };

  formatDate(date) {
    date = date.split("-");
    return `${date[2]}-${date[1]}-${date[0]}`;
  }

  fetchJSON = async (JSON_data) => {
    const { clients } = this.state;
    if (JSON_data.hasOwnProperty("vehicle")) {
      let insuranceClients =
        (await clients) && clients.length > 0 && clients.map((e) => e.Name);
      this.setState(
        {
          customerJSON: JSON_data,
          vin: JSON_data.vehicle.vin,
          regNo: JSON_data.vehicle.nr,
          // estimateId: "estimate ID",
          color: JSON_data.vehicle.color,
          make: JSON_data.vehicle.maker,
          model: JSON_data.vehicle.model,
          email: JSON_data.customer.email,
          // comment: JSON_data.vehicle.color,
          // qrClient: JSON_data.customer.creator,
          // claimNumber: JSON_data.vehicle.color,
          customerCompany: JSON_data.customer.company,
          // PartnerName: JSON_data.vehicle.color,
          kilometerStand: JSON_data.vehicle.mileage,
          InsurenceName: insuranceClients.includes(JSON_data.customer.insurance)
            ? JSON_data.customer.insurance
            : "Adi",
        },
        () => {
          const { make, makeModel, model } = this.state;
          let Models = makeModel.filter((data) => {
            return data.Make == make;
          });
          let makeModels = makeModel;
          if (Models.length == 0) {
            Models = this.getModals(make);
            makeModels = [
              {
                Make: make,
                Model: [model, ...Models, ...this.state.Models].sort(),
              },
              ...makeModel,
            ];
            this.setState({
              Models: [model, ...this.state.Models, ...Models].sort(),
              makeModel: makeModels,
            });
          } else if (!Models[0].Model.includes(model)) {
            this.setState({
              Models: Models.length ? [model, ...Models[0].Model].sort() : "",
            });
          } else {
            this.setState({
              Models: Models.length ? Models[0].Model : "",
            });
          }

          this.setState(
            {
              loader: false,
            },
            () => {
              this.refs.JSONFileUploader.value = "";
            }
          );
        }
      );
    } else {
      this.setState({
        loader: false,
      });
      Toast.fire({
        type: "error",
        title: "JSON file isn't valid!",
      }).then(() => {
        this.refs.JSONFileUploader.value = "";
      });
    }
  };

  handleFileChange = (uploadedFile) => {
    this.setState({
      loader: true,
    });
    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      try {
        this.fetchJSON(JSON.parse(fileReader.result));
      } catch (e) {
        Toast.fire({
          type: "error",
          title: "JSON file isn't valid!",
        }).then(() => {
          this.setState(
            {
              loader: false,
            },
            () => {
              this.refs.JSONFileUploader.value = "";
            }
          );
        });
      }
    };
    if (uploadedFile !== undefined) {
      fileReader.readAsText(uploadedFile);
    }
  };

  getObjKey = (lang) => {
    let keyName = lang;
    if (["de", "ch", "fr-ch"].includes(lang)) {
      keyName = "de";
    } else if (["fr-fr"].includes(lang)) {
      keyName = "fr";
    } else if (["us", "gb", "au", "ku", "ar"].includes(lang)) {
      keyName = "us";
    }

    if (!Object.keys(this.state.colorArr).includes(keyName)) {
      return "us";
    }

    return keyName || "us";
  };

  render() {
    //const selectedFile = localStorage.getItem("selectedFile");
    const {
      vin,
      regNo,
      error,
      legacyMode,
      isUpdate,
      actualVin,
      colorArr,
      regDate,
      loader,
      customerJSON,
    } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");
    return (
      <div className="animated fadeIn create_qr_main_wrapper">
        <Card>
          <Row>
            <Col md="12" sm="12">
              <Card>
                {/* <small className="">{this.lang("Create QR")} </small> */}
                {/* <small> VIN Number : {localStorage.getItem("selectedFile")}</small> */}
                {!this.state.isUpdate && (
                  <CardHeader className="d-flex align-items-center create_qr_header justify-content-between">
                    <>
                      <div>
                        <button
                          className="btn btn-danger"
                          type="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                          style={{ margin: "10px 10px 10px 0px" }}
                          aria-label="Dropdown toggle"
                          onClick={() => this.toggle("scanner")}
                        >
                          {this.lang("scanQRCode")}
                        </button>
                        <span
                          className=" m-0 mx-3"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          {this.lang("or")}
                        </span>
                        <button
                          className="btn btn-danger"
                          type="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                          style={{ margin: "10px 10px 10px 10px" }}
                          aria-label="Dropdown toggle"
                          onClick={() => this.toggle("file")}
                        >
                          {this.lang("browseQRCode")}
                        </button>
                      </div>
                      {hzdPartnerIdList.includes(partnerId) && (
                        <div>
                          <input
                            type="file"
                            ref="JSONFileUploader"
                            accept="application/JSON"
                            onChange={(e) =>
                              this.handleFileChange(e.target.files[0])
                            }
                            style={{
                              display: "none",
                            }}
                          />
                          <button
                            className="btn btn-danger mr-auto"
                            type="button"
                            aria-expanded="false"
                            aria-haspopup="true"
                            style={{ margin: "10px 10px 10px 10px" }}
                            aria-label="Dropdown toggle"
                            onClick={(e) => {
                              this.refs.JSONFileUploader.click();
                            }}
                            disabled={loader}
                          >
                            {loader ? (
                              <div className="text-center">
                                <div className="spinner-border" role="status">
                                  <span className="sr-only">Loading...</span>
                                </div>
                              </div>
                            ) : (
                              this.lang("Browse JSON")
                            )}
                          </button>
                          {Object.keys(customerJSON).length > 0 && (
                            <Button
                              className="mx-2 btn btn-danger"
                              title="Clear JSON"
                              onClick={() =>
                                this.setState({ customerJSON: {} })
                              }
                            >
                              <i className="fa fa-close" />
                            </Button>
                          )}
                        </div>
                      )}
                    </>
                  </CardHeader>
                )}
                <div className="row vertical-align-middle create_qr_content mt-3">
                  {client === "SWISS" && (
                    <Col md="4">
                      <FormGroup>
                        <Label htmlFor="city">
                          {this.lang("Order NO")}{" "}
                          {client === "SWISS" && (
                            <span style={{ fontSize: "10.5px" }}>
                              <span
                                style={{ fontSize: "15.5px", color: "red" }}
                              >
                                *{" "}
                              </span>
                              <b style={{ fontSize: "9px", fontWeight: "900" }}>
                                ({this.lang("orderNoIsUsedAsMainRecordID")})
                              </b>
                            </span>
                          )}
                        </Label>
                        <Input
                          type="text"
                          id="city"
                          onChange={this.handleChange}
                          name="estimateId"
                          value={this.state.estimateId}
                          disabled={isUpdate && client === "SWISS"}
                        />
                        {error.includes("orderID") && (
                          <span style={{ color: "red" }}>
                            {this.lang("pleaseEnterOrderID")}
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                  )}
                  <Col md="4 ">
                    <Label htmlFor="city">{this.lang("VIN Number")}</Label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder=""
                        onChange={this.handleChange}
                        value={
                          client === "SWISS"
                            ? actualVin.toUpperCase()
                            : vin.toUpperCase()
                        }
                        disabled={
                          partnerId !== "M-220701" && this.state.isUpdate
                        }
                        name={client === "SWISS" ? "actualVin" : "vin"}
                      />
                      <div className="input-group-append dropdown">
                        <button
                          className="dropdown-toggle btn btn-danger"
                          type="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                          aria-label="Dropdown toggle"
                          onClick={(e) => {
                            this.refs.fileUploader.click();
                          }}
                          disabled={
                            partnerId !== "M-220701" && this.state.isUpdate
                          }
                        >
                          Use Camera
                        </button>
                        <input
                          type="file"
                          name="image"
                          id="file"
                          ref="fileUploader"
                          style={{ display: "none" }}
                          onChange={(e) => this.getOcr(e, "vin")}
                        />
                        <div
                          className="dropdown-menu"
                          role="menu"
                          aria-hidden="true"
                          data-popper-placement="bottom-start"
                        ></div>
                      </div>
                    </div>
                    {/* {error.includes('VIN') && <span style={{color : "red"}}>Please Enter VIN</span>} */}
                    {error.includes("inValidVIN") && (
                      <>
                        <span style={{ color: "red" }}>
                          {this.lang("validVINMsg")}
                        </span>
                        <br />
                      </>
                    )}
                    {error.includes("maxLength") && (
                      <span style={{ color: "red" }}>
                        {this.lang("maxLengthMsg")}
                      </span>
                    )}
                  </Col>
                  <Col md="4 ">
                    <Label htmlFor="city">
                      {this.lang("Registration No.")}
                    </Label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder=""
                        onChange={this.handleChange}
                        value={regNo}
                        name="regNo"
                      />
                      <div className="input-group-append dropdown">
                        <button
                          className="dropdown-toggle btn btn-danger"
                          type="button"
                          aria-expanded="false"
                          aria-haspopup="true"
                          aria-label="Dropdown toggle"
                          onClick={(e) => {
                            this.refs.regNoUploader.click();
                          }}
                        >
                          Use Camera
                        </button>
                        <input
                          type="file"
                          name="image"
                          id="file"
                          ref="regNoUploader"
                          style={{ display: "none" }}
                          onChange={(e) => this.getOcr(e, "regNo")}
                        />
                        <div
                          className="dropdown-menu"
                          role="menu"
                          aria-hidden="true"
                          data-popper-placement="bottom-start"
                        ></div>
                      </div>
                    </div>
                  </Col>
                  {client !== "SWISS" && (
                    <Col md="4">
                      <FormGroup>
                        <Label htmlFor="city">{this.lang("Order NO")}</Label>
                        <Input
                          type="text"
                          id="city"
                          onChange={this.handleChange}
                          name="estimateId"
                          value={this.state.estimateId}
                          disabled={isUpdate && client === "SWISS"}
                        />
                        {error.includes("orderID") && (
                          <span style={{ color: "red" }}>
                            {this.lang("pleaseEnterOrderID")}
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                  )}
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="city">{this.lang("Color")}</Label>

                      <div className="input-group">
                        <input
                          className="form-control"
                          type="email"
                          id="input2-group3"
                          name="color"
                          placeholder="Select Color"
                          disabled
                          onChange={this.handleChange}
                          value={this.lang(this.state.color)}
                        />
                        <div className="input-group-append dropdown">
                          <select
                            name="color"
                            className="form-control p-2"
                            onChange={this.handleChange}
                            value={this.state.color}
                          >
                            <option value="">-- Select --</option>
                            {colorArr[this.getObjKey(this.state.lang)].map(
                              (row, ind) => (
                                <option key={ind} value={row.title}>
                                  {" "}
                                  {this.lang(row.title)}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="city">{this.lang("Make")}</Label>
                      {/* <Input
                        type="text"
                        id="city"
                        onChange={this.handleChange}
                        name="make"
                        value={this.state.make}
                      /> */}

                      <select
                        className="form-control"
                        placeholder="Make"
                        onChange={(e) => {
                          const Models = this.state.makeModel.filter((t) => {
                            return t.Make == e.target.value;
                          });

                          this.setState({
                            make: e.target.value,
                            Models: Models[0].Model,
                          });
                        }}
                        value={this.state.make}
                        name="make"
                      >
                        <option>-- Select--</option>
                        {this.state.makeModel.map((r, j) => (
                          <Fragment key={j}>
                            {r.label ? (
                              <option disabled style={{ fontWeight: "800" }}>
                                {this.lang(r.label)}
                              </option>
                            ) : (
                              <option value={r.Make}>{r.Make}</option>
                            )}
                          </Fragment>
                        ))}
                      </select>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="city">{this.lang("Model")}</Label>
                      <select
                        className="form-control"
                        placeholder="Model"
                        onChange={this.handleChange}
                        value={this.state.model}
                        name="model"
                      >
                        <option>--Select --</option>
                        {this.state.Models.length &&
                          this.state.Models.map((r, j) => (
                            <option key={j} value={r}>
                              {r}
                            </option>
                          ))}
                      </select>

                      {/* <Input
                        type="text"
                        id="city"
                        onChange={this.handleChange}
                        name="model"
                        value={this.state.model}
                      /> */}
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="city">{this.lang("Email")}</Label>
                      <Input
                        type="text"
                        onChange={this.handleChange}
                        name="email"
                        value={this.state.email}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="city">{this.lang("Notes")}</Label>
                      <Input
                        type="text"
                        onChange={this.handleChange}
                        name="comment"
                        value={this.state.comment}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="city">{this.lang("Contractor")}</Label>
                      <Input
                        type="text"
                        onChange={this.handleChange}
                        name="qrClient"
                        value={this.state.qrClient}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="city">{this.lang("Claim number")}</Label>
                      <Input
                        type="text"
                        onChange={this.handleChange}
                        name="claimNumber"
                        value={this.state.claimNumber}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="city">
                        {this.lang("Customer Company")}
                      </Label>
                      <Input
                        type="text"
                        id="customerCompany"
                        onChange={this.handleChange}
                        name="customerCompany"
                        value={this.state.customerCompany}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="city">{this.lang("Customer Name")}</Label>
                      {/* <Input
                        type="text"
                        id="PartnerName"
                        onChange={this.handleChange}
                        name="PartnerName"
                        value={this.state.PartnerName}
                      /> */}
                      <Input
                        type="text"
                        id="customerName"
                        onChange={this.handleChange}
                        name="customerName"
                        value={this.state.customerName}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="city">
                        {this.lang("Kilometer Stand")}
                      </Label>
                      <Input
                        type="text"
                        id="kilometerStand"
                        onChange={this.handleChange}
                        name="kilometerStand"
                        value={this.state.kilometerStand}
                      />
                    </FormGroup>
                  </Col>
                  {(partnerId === "15-220410" || partnerId === "demo-cz") && (
                    <>
                      <Col md="4">
                        <FormGroup>
                          <Label htmlFor="postal-code">
                            {this.lang("Category")}
                          </Label>
                          <select
                            className="form-control"
                            placeholder="Category"
                            onChange={this.handleChange}
                            //  defaultValue={this.state.InsurenceName}
                            value={this.state.Category}
                            name="Category"
                          >
                            {this.state.categoryList &&
                              this.state.categoryList.length &&
                              this.state.categoryList.map((r, i) => (
                                <option key={i} style={{ color: "red" }}>
                                  {r}
                                </option>
                              ))}
                          </select>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label htmlFor="city">
                            {this.lang("registrationDate")}
                          </Label>
                          <Input
                            type="date"
                            id="regDate"
                            onChange={this.handleChange}
                            name="regDate"
                            value={regDate}
                          />
                        </FormGroup>
                      </Col>
                    </>
                  )}
                  <Col md="2">
                    <FormGroup>
                      <Label htmlFor="postal-code">
                        {this.lang("Insurance Client")}
                      </Label>
                      <select
                        className="form-control"
                        placeholder="Insurance client"
                        onChange={(e) => this.handleChange(e, "InsurenceName")}
                        //  defaultValue={this.state.InsurenceName}
                        value={this.state.qrClient}
                        name="qrClient"
                      >
                        {this.state.clients &&
                          this.state.clients.length &&
                          this.state.clients.map((r, i) => (
                            <Fragment key={i}>
                              {/* {partnerId === '15-220410' ?  */}
                              {partnerId === "15-220410" ||
                              partnerId === "demo-cz" ? (
                                <option
                                  style={{
                                    fontWeight: `${
                                      [
                                        "Axa",
                                        "Slavia",
                                        "Direct",
                                        "Audatex",
                                        "Allianz",
                                        "AQ-SK",
                                      ].includes(r.Name)
                                        ? "800"
                                        : ""
                                    }`,
                                    color: `${
                                      [
                                        "Axa",
                                        "Slavia",
                                        "Direct",
                                        "Audatex",
                                        "Allianz",
                                        "AQ-SK",
                                      ].includes(r.Name)
                                        ? ""
                                        : "red"
                                    }`,
                                  }}
                                >
                                  {r.Name}
                                </option>
                              ) : (
                                <option>{r.Name}</option>
                              )}
                            </Fragment>
                          ))}
                      </select>
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup>
                      {/* <img
                        src={`/InsurenceClients/${partnerId}/${this.state.InsurenceName}.png`}
                        width="150"
                        alt={this.state.InsurenceName}
                      /> */}

                      <img
                        width="100%"
                        alt={this.state.InsurenceName}
                        src={`${
                          configuration.imagePath
                        }/scanImages/${partnerId}/insurenceClients/${
                          this.state.insurenceLogo || "Adi.png"
                        }`}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <CardText>{this.state.qrString}</CardText>
                  </Col>
                  <Col lg="12" className="text-right">
                    {this.state.isUpdate ? (
                      <button
                        className="btn btn-danger btn-lg"
                        onClick={() => this.update()}
                      >
                        {this.lang("Update QR Details")}
                      </button>
                    ) : (
                      <>
                        <button
                          className="btn btn-danger btn-lg"
                          onClick={this.save}
                        >
                          {`${this.lang("Create Order")} / ${this.lang(
                            "Create QR"
                          )}`}
                        </button>
                      </>
                    )}
                  </Col>
                </div>

                {/* <div className="card-footer mt-3">
                  <div className="row align-items-center p-0">
                    <div className="col-lg-6 col-md-6 col-sm-12 button_switch_left_wrapper">
                       <Link className="glass" to="/qrlist">
                        <button
                          style={{ marginRight: 10 }}
                          className="btn btn-danger btn-sm pull-left"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </Link>
                      <Link className="glass" to="/customer-info">
                        <button className="btn btn-danger btn-sm pull-left">
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </Link> 
                      
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                      {this.state.isUpdate ?
                        <button
                          className="btn btn-danger btn-lg"
                          onClick={() => this.update()}
                        >
                          {this.lang("Update QR Details")}
                        </button>
                        :
                        <>
                          <button
                            className="btn btn-danger btn-lg"
                            onClick={this.save}
                          >
                            {`${this.lang("Create Order")} / ${this.lang("Create QR")}`}
                          </button>
                        </>
                      }
                    </div>
                  </div>
                </div> */}
              </Card>
            </Col>
          </Row>
          {/* Modal For QR */}
          <Modal
            toggle={() => this.toggle()}
            isOpen={this.state.modal}
            size="lg"
            centered
          >
            <ModalHeader className="p-2" toggle={() => this.toggle()}>
              {this.lang("QR Scanner")}
            </ModalHeader>
            <ModalBody>
              <div className="row">
                <div className="col-12">
                  <ScanQR
                    legacyMode={legacyMode}
                    scanQrData={this.state.scanQrData}
                    handleScanWebCam={this.handleScanWebCam}
                  />
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              {" "}
              <Button className="btn-danger" onClick={() => this.toggle()}>
                {this.lang("Cancel")}
              </Button>
            </ModalFooter>
          </Modal>
          {/* Modal For Scanner Option */}
          {/* <Modal size="lg" isOpen={this.state.optionModal}  className='modal1 pass_fail_modal'>
                  <ModalHeader>Choose an option</ModalHeader>
                    <ModalBody>
                      <FormGroup>
                        <div className="row">
                          <div className="form-check col">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" value="webcam" id="webcam" onChange={(e)=>this.modalChange(e)} />
                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                              Scan QR
                            </label>
                          </div>
                          <div className="form-check col">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" value="file" id="file" onChange={(e)=>this.modalChange(e)} />
                            <label className="form-check-label" htmlFor="flexRadioDefault2">
                              Upload QR
                            </label>
                          </div>
                          <div className="form-check col">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" value="scanBarcode" id="scanBar" onChange={(e)=>this.modalChange(e)} />
                            <label className="form-check-label" htmlFor="flexRadioDefault3">
                              Scan Barcode/QR
                            </label>
                          </div>
                          <div className="form-check col">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" value="scanNumber" id="scanNumber" onChange={(e)=>this.modalChange(e)} />
                            <label className="form-check-label" htmlFor="flexRadioDefault4">
                              Scan Registration plate
                            </label>
                          </div>
                          <div className="form-check col">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" value="detectText" id="detectText" onChange={(e)=>this.modalChange(e)} />
                            <label className="form-check-label" htmlFor="flexRadioDefault5">
                              Upload Barcode/Registration plate
                            </label>
                          </div>
                        </div>
                      </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" onClick={()=>this.optionModalToggle()}>Select</Button>
                      <Button color="secondary" onClick={()=>this.setState({optionModal : false})}>Cancel</Button>
                    </ModalFooter>
                </Modal> */}
        </Card>
      </div>
    );
  }
}

//export default Colors;
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(CreateQr);
